import { useMutation } from "@tanstack/react-query";
import { useAtomValue, useSetAtom } from "jotai";
import useCloudPermissions from "../../../../hooks/useCloudPermissions";
import {
  restoringBackupAtom,
  tenantIDAtom,
} from "../../../../atoms/GlobalAtoms";
import TenantAPI from "../../../api/TenantAPI";
import { newToastEvent } from "../../../../utils/ToastUtil";
import { getErrorMessage } from "../../../../utils/GeneralUtils";

// Used to restore an individual cloud backup.
const useRestoreBackup = () => {
  const { cPermissions } = useCloudPermissions();
  const tenantID = useAtomValue(tenantIDAtom);
  const setRestoring = useSetAtom(restoringBackupAtom);

  const restoreBackup = useMutation({
    mutationFn: ({
      backupID,
      backupDate,
    }: {
      backupID: string;
      backupDate?: string;
    }) => {
      // TODO: Add cPermissions scope here
      if (false) {
        return Promise.reject("You don't have permission to restore backups");
      }

      if (!tenantID) return Promise.reject("An unexpected error occurred.");

      setRestoring(true);

      return TenantAPI.restoreBackup(tenantID, backupID);
    },
    onError: (err) => {
      setRestoring(false);
      newToastEvent("error", "We failed to restore your backup.");
      console.log(err);
    },
  });

  return {
    restoreBackup: restoreBackup.mutate,
    restoreError: restoreBackup.error
      ? getErrorMessage(restoreBackup.error)
      : null,
  };
};

export default useRestoreBackup;
